module.exports = __webpack_public_path__ + "static/media/ky.ac48acea.svg";